import { IconSparkles } from "@tabler/icons-react";
import styles from "../Feed.module.css";

const TalentsHero = ({ available, matches, shortlisted }) => {
  return (
    <div className={styles.hero}>
      <div className={styles.heroText}>
        <div className={styles.heroEyebrow}>
          <IconSparkles size={14} /> Talent Pool
        </div>
        <div className={styles.heroTitle}>Find your next great hire</div>
        <div className={styles.heroSub}>
          Browse available talent, review who matched with your jobs, and keep
          your favourites in one shortlist.
        </div>
      </div>
      {/* <div className={styles.heroStats}>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{available}</div>
          <div className={styles.heroStatLabel}>Available</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{matches}</div>
          <div className={styles.heroStatLabel}>Matches</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{shortlisted}</div>
          <div className={styles.heroStatLabel}>Shortlisted</div>
        </div>
      </div> */}
    </div>
  );
};
export default TalentsHero;
